import { add, collection, doc } from './common'
import { composeQuery, getRootCollection } from './queries'
import { getUserId } from './users'

export const listCustomers = () => getRootCollection('customers')

const checkoutSessions = collection('checkout_sessions')

export const listCheckoutSessions = (user) =>
  composeQuery(listCustomers, doc(getUserId(user)), checkoutSessions)

export const createCheckoutSession = (user, data) =>
  composeQuery(() => listCheckoutSessions(user), add(data))
